import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Text } from '../Text';

const StyledText = styled(Text)`
  font-weight: 600;
`;

const HorizontalTabItemWrapper = styled.button.attrs(() => ({ type: 'button', role: 'tab' }))`
  display: flex;
  align-items: center;
  justify-content: center;

  flex-grow: 0;
  flex-shrink: 0;
  white-space: no-wrap;

  border: 0;
  background: none;
  cursor: pointer;

  color: var(--font-icon);
  opacity: ${({ active }) => (active ? 1 : 0.5)};
  padding: 10px 0;

  transition: color 150ms linear, background 100ms linear;

  &:focus:not(:active),
  &:focus-visible:not(:active) {
    outline: none;
    background: var(--background);
    color: var(--font-icon);
    border-radius: 4px;
  }
`;

const HorizontalTabItem = forwardRef(
  ({ active = false, children = null, onClick }, forwardedRef) => (
    <HorizontalTabItemWrapper onClick={onClick} active={active} ref={forwardedRef}>
      <StyledText as='span'>{children}</StyledText>
    </HorizontalTabItemWrapper>
  )
);

HorizontalTabItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  active: PropTypes.bool
};

export { HorizontalTabItem };
